<template>
  <div class="casesPage">
    <page-banner
      :info="{
        url: require('@img/banner_5.jpg'),
        title: this.$t(`cases.bannerTitle`),
        text: this.$t(`cases.bannerText`),
      }"
    ></page-banner>
    <div class="cases">
      <div class="casesHeader">
        <div class="container">
          <part-title
            class="wow fadeInUp"
            :title="$t(`cases.bannerTitle`)"
            style="margin-bottom: 40px"
          ></part-title>
          <div class="caseList" v-for="listIndex in 2" :key="listIndex">
            <div
              class="caseItem"
              :class="{
                last: itemIndex == 7,
                'active animate__animated animate__headShake':
                  activeIndex == (listIndex - 1) * 7 + (itemIndex - 1),
              }"
              v-for="itemIndex in 7"
              :key="itemIndex"
              :data-wow-delay="(itemIndex - 1) * 0.1 + 's'"
              @click="hoverItem((listIndex - 1) * 7 + (itemIndex - 1))"
            >
              <img
                class="wow fadeInUp"
                :data-wow-delay="(itemIndex - 1) * 0.1 + 's'"
                :src="
                  caseInfoList[(listIndex - 1) * 7 + (itemIndex - 1)][
                    activeIndex == (listIndex - 1) * 7 + (itemIndex - 1)
                      ? 'activeIcon'
                      : 'icon'
                  ]
                "
                alt
              />
              <span
                class="wow fadeInUp"
                :data-wow-delay="(itemIndex - 1) * 0.1 + 's'"
                >{{
                  $t(
                    `cases.${
                      caseInfoList[(listIndex - 1) * 7 + (itemIndex - 1)].text
                    }`
                  )
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="caseContent">
        <!-- 1 -->
        <div class="container" v-show="activeIndex == 0">
          <div class="bgRect animate__animated animate__slideInLeft"></div>
          <img
            class="caseImg animate__animated animate__slideInLeft"
            src="@img/product/1_hedian.png"
            alt
          />
          <div class="caseIntro animate__animated animate__slideInRight">
            <div class="caseIntroTitle">
              <img :src="caseInfoList[activeIndex].icon" alt />
              <span>{{ $t(`cases.${caseInfoList[activeIndex].text}`) }}</span>
            </div>
            <p>
              {{ $t("cases.case1.p1") }}
            </p>
            <p>{{ $t("cases.case1.p2") }}:</p>
            <div style="text-align: center">
              <img class="caseIntroImg" src="@img/product/1_fun.png" />
            </div>
            <p>
              {{ $t("cases.case1.p3") }}
            </p>
            <p>
              · {{ $t("cases.case1.p4") }} <span>10.52%</span>{{ $t("cases.case1.p5") }} <span>76.33%</span>{{ $t("cases.case1.p6") }}<span>27.97%</span>.
            </p>
            <p>
              · {{ $t("cases.case1.p7") }} <span>0.012kg/s</span
              >{{ $t("cases.case1.p8") }}<span>21.43%</span>.
            </p>
          </div>
        </div>
        <!-- 2 -->
        <div class="container" v-show="activeIndex == 1">
          <div class="bgRect animate__animated animate__slideInLeft"></div>
          <img
            class="caseImg animate__animated animate__slideInLeft"
            src="@img/product/2_car.png"
            alt
          />
          <div class="caseIntro animate__animated animate__slideInRight">
            <div class="caseIntroTitle">
              <img :src="caseInfoList[activeIndex].icon" alt />
              <span>{{ $t(`cases.${caseInfoList[activeIndex].text}`) }}</span>
            </div>
            <p>{{ $t("cases.case2.p1") }}</p>
            <img class="caseIntroImg" src="@img/product/2_fun.png" />
            <p>
              {{ $t("cases.case2.p2") }}<span> 10%</span
              >{{ $t("cases.case2.p3") }}
            </p>
          </div>
        </div>
        <!-- 3 -->
        <div class="container" v-show="activeIndex == 2">
          <div
            class="bgRect animate__animated animate__slideInLeft"
            style="width: 315px"
          ></div>
          <img
            class="caseImg animate__animated animate__slideInLeft"
            src="@img/product/3_light.png"
            alt
          />
          <div class="caseIntro animate__animated animate__slideInRight">
            <div class="caseIntroTitle">
              <img :src="caseInfoList[activeIndex].icon" alt />
              <span>{{ $t(`cases.${caseInfoList[activeIndex].text}`) }}</span>
            </div>
            <p>{{ $t("cases.case3.p1") }}</p>
            <div style="text-align: center">
              <img class="caseIntroImg" src="@img/product/3_fun.jpg" />
            </div>

            <p>
              {{ $t("cases.case3.p2") }}
            </p>
            <p>
              {{ $t("cases.case3.p3") }}
            </p>
            <p>
              {{ $t("cases.case3.p4") }}
              <span>23.33%</span>{{ $t("cases.case3.p5") }}
            </p>
          </div>
        </div>
        <!-- 4 -->
        <div class="container" v-show="activeIndex == 3">
          <div class="bgRect animate__animated animate__slideInLeft"></div>
          <img
            class="caseImg animate__animated animate__slideInLeft"
            src="@img/product/4_ranliaodianchi.png"
            alt
          />
          <div class="caseIntro animate__animated animate__slideInRight">
            <div class="caseIntroTitle">
              <img :src="caseInfoList[activeIndex].icon" alt />
              <span>{{ $t(`cases.${caseInfoList[activeIndex].text}`) }}</span>
            </div>
            <p>{{ $t("cases.case4.p1") }}</p>
            <p>
              {{ $t("cases.case4.p2") }}<span>{{ $t("cases.case4.p3") }}</span
              >{{ $t("cases.case4.p4") }}
            </p>
            <p>
              {{ $t("cases.case4.p5") }}
            </p>
            <p>
              {{ $t("cases.case4.p6") }}
            </p>
            <p>{{ $t("cases.case4.p7") }}</p>
            <div style="text-align: center">
              <img class="caseIntroImg" src="@img/product/4_fun.png" />
            </div>
            <p>{{ $t("cases.case4.p8") }}</p>
            <p>
              {{ $t("cases.case4.p9") }}
            </p>
            <p>{{ $t("cases.case4.p10") }}</p>
            <p>
              {{ $t("cases.case4.p11") }}
              <span>22.60％</span>{{ $t("cases.case4.p12") }}<span> 2.83％</span
              >{{ $t("cases.case4.p13") }}
            </p>
          </div>
        </div>
        <!-- 5 -->
        <div class="container" v-show="activeIndex == 4">
          <div class="bgRect animate__animated animate__slideInLeft"></div>
          <img
            class="caseImg animate__animated animate__slideInLeft"
            src="@img/product/13_1.png"
            style="background: #fff"
            alt
          />
          <div class="caseIntro animate__animated animate__slideInRight">
            <div class="caseIntroTitle">
              <img :src="caseInfoList[activeIndex].icon" alt />
              <span>{{ $t(`cases.${caseInfoList[activeIndex].text}`) }}</span>
            </div>
            <p>{{ $t("cases.case5.p1") }}</p>
            <img class="caseIntroImg" src="@img/product/13_2.jpg" />
            <img class="caseIntroImg" src="@img/product/13_3.png" />
            <p>{{ $t("cases.case5.p2") }}</p>
            <p>
              {{ $t("cases.case5.p3") }}<span>170</span>
              {{ $t("cases.case5.p4") }}
            </p>
            <p>
              {{ $t("cases.case5.p5") }}
              <span>4844.8kg</span>{{ $t("cases.case5.p6")
              }}<span>4562.7kg</span>{{ $t("cases.case5.p7") }}
              <span>5.82%</span>。
            </p>
          </div>
        </div>
        <!-- 6 -->
        <div class="container" v-show="activeIndex == 5">
          <div class="bgRect animate__animated animate__slideInLeft"></div>
          <img
            class="caseImg animate__animated animate__slideInLeft"
            src="@img/product/6_wurenji.png"
            alt
          />
          <div class="caseIntro animate__animated animate__slideInRight">
            <div class="caseIntroTitle">
              <img :src="caseInfoList[activeIndex].icon" alt />
              <span>{{ $t(`cases.${caseInfoList[activeIndex].text}`) }}</span>
            </div>
            <p>{{ $t("cases.case6.p1") }}</p>
            <p>{{ $t("cases.case6.p2") }}</p>
            <img class="caseIntroImg" src="@img/product/6_fun_1205.png" />
            <p>
              {{ $t("cases.case6.p3") }}<span>7%</span
              >{{ $t("cases.case6.p4") }}
            </p>
          </div>
        </div>
        <!-- 7 三相接触器-->
        <div class="container" v-show="activeIndex == 6">
          <div class="bgRect animate__animated animate__slideInLeft"></div>
          <img
            class="caseImg animate__animated animate__slideInLeft"
            src="@img/product/14_sanxiang_4.png"
            style="width: 430px; height: auto"
            alt
          />
          <div class="caseIntro animate__animated animate__slideInRight">
            <div class="caseIntroTitle">
              <img :src="caseInfoList[activeIndex].icon" alt />
              <span>{{
                `Triple-phase Contactors(` +
                $t(`cases.${caseInfoList[activeIndex].text}`) +
                ")"
              }}</span>
            </div>
            <p>
              {{ $t("cases.case7.p1") }}
            </p>
            <p>
              {{ $t("cases.case7.p2") }}
            </p>
            <p>
              {{ $t("cases.case7.p3") }}
            </p>
            <p>
              {{ $t("cases.case7.p4") }}
            </p>
          </div>
        </div>
        <!-- 8 -->
        <div class="container" v-show="activeIndex == 7">
          <div class="bgRect animate__animated animate__slideInLeft"></div>
          <img
            class="caseImg animate__animated animate__slideInLeft"
            src="@img/product/7_yali.png"
            alt
          />
          <div class="caseIntro animate__animated animate__slideInRight">
            <div class="caseIntroTitle">
              <img :src="caseInfoList[activeIndex].icon" alt />
              <span>{{ $t(`cases.${caseInfoList[activeIndex].text}`) }}</span>
            </div>
            <p>{{ $t("cases.case8.p1") }}</p>
            <p>
              {{ $t("cases.case8.p2") }}
            </p>
            <div style="text-align: center">
              <img
                class="caseIntroImg"
                src="@img/product/6_fun.png"
                style="height: 200px"
              />
            </div>
            <p>
              {{ $t("cases.case8.p3") }}
            </p>
            <p>
              {{ $t("cases.case8.p4") }}
              <span>11.14%</span>{{ $t("cases.case8.p5") }} <span>36</span
              >{{ $t("cases.case8.p6") }} <span>144</span>
              {{ $t("cases.case8.p7") }}
            </p>
          </div>
        </div>
        <!-- 9 -->
        <div class="container" v-show="activeIndex == 8">
          <div class="bgRect animate__animated animate__slideInLeft"></div>
          <img
            class="caseImg animate__animated animate__slideInLeft"
            src="@img/product/8_he.png"
            alt
          />
          <div class="caseIntro animate__animated animate__slideInRight">
            <div class="caseIntroTitle">
              <img :src="caseInfoList[activeIndex].icon" alt />
              <span>{{ $t(`cases.${caseInfoList[activeIndex].text}`) }}</span>
            </div>
            <p>
              {{ $t("cases.case9.p1") }}
            </p>
            <div style="text-align: center">
              <img class="caseIntroImg" src="@img/product/he.jpg" />
            </div>
            <p>
              {{ $t("cases.case9.p2") }}
            </p>
            <p>
              {{ $t("cases.case9.p3") }}
            </p>
            <p>
              {{ $t("cases.case9.p4") }}
              <span>1.56%</span>{{ $t("cases.case9.p5") }} <span>1.27%</span
              >{{ $t("cases.case9.p6") }} <span>1.04%</span
              >{{ $t("cases.case9.p7") }} <span>63.43%</span
              >{{ $t("cases.case9.p8") }}
            </p>
          </div>
        </div>
        <!-- 10 -->
        <div class="container" v-show="activeIndex == 9">
          <div class="bgRect animate__animated animate__slideInLeft"></div>
          <img
            class="caseImg animate__animated animate__slideInLeft"
            src="@img/product/7_tesila.png"
            alt
          />
          <div class="caseIntro animate__animated animate__slideInRight">
            <div class="caseIntroTitle">
              <img :src="caseInfoList[activeIndex].icon" alt />
              <span>{{ $t(`cases.${caseInfoList[activeIndex].text}`) }}</span>
            </div>
            <p>{{ $t("cases.case10.p1") }}</p>
            <img class="caseIntroImg" src="@img/product/7_fun.png" />
            <p>{{ $t("cases.case10.p2") }}</p>
            <p>
              {{ $t("cases.case10.p3") }}
              <span>4.32%</span>。
            </p>
          </div>
        </div>
        <!-- 11 -->
        <div class="container" v-show="activeIndex == 10">
          <div class="bgRect animate__animated animate__slideInLeft"></div>
          <img
            class="animate__animated animate__slideInLeft"
            style="
              width: auto;
              height: 570px;
              margin: 20px 0 0 20px;
              background: #fff;
            "
            src="@img/product/8_yaozhui.png"
            alt
          />
          <img
            class="caseImg animate__animated animate__slideInLeft"
            style="
              margin-left: 0px;
              border: 1px solid rgb(51, 51, 51);
              border-radius: 0;
              box-shadow: none;
            "
            src="@img/product/8_yaozhui_2.gif"
            alt
          />
          <div class="caseIntro animate__animated animate__slideInRight">
            <div class="caseIntroTitle">
              <img :src="caseInfoList[activeIndex].icon" alt />
              <span>{{ $t(`cases.${caseInfoList[activeIndex].text}`) }}</span>
            </div>
            <p>
              {{ $t("cases.case11.p1") }}
            </p>
            <p>
              {{ $t("cases.case11.p2") }}
            </p>
            <p>
              {{ $t("cases.case11.p3") }}
              <span> {{ $t("cases.case11.p4") }}</span>
              {{ $t("cases.case11.p5") }}
              <span> {{ $t("cases.case11.p6") }}</span
              >{{ $t("cases.case11.p7") }}
            </p>
          </div>
        </div>
        <!-- 12 -->
        <div class="container" v-show="activeIndex == 11">
          <div class="bgRect animate__animated animate__slideInLeft"></div>
          <img
            class="caseImg animate__animated animate__slideInLeft"
            src="@img/product/10_huoijian.png"
            alt
          />
          <div class="caseIntro animate__animated animate__slideInRight">
            <div class="caseIntroTitle">
              <img :src="caseInfoList[activeIndex].icon" alt />
              <span>{{ $t(`cases.${caseInfoList[activeIndex].text}`) }}</span>
            </div>
            <p>
              {{ $t("cases.case12.p1") }}
            </p>
            <p>{{ $t("cases.case12.p2") }}:</p>
            <img class="caseIntroImg" src="@img/product/9_fun.png" />
            <p>{{ $t("cases.case12.p3") }}{{ $t("cases.case13.p4") }}</p>
            <p>
              {{ $t("cases.case12.p5") }}<span>{{ $t("cases.case12.p6") }}</span
              >{{ $t("cases.case12.p7")
              }}<span>{{ $t("cases.case12.p8") }}</span
              >{{ $t("cases.case12.p9") }}
            </p>
          </div>
        </div>
        <!-- 13 -->
        <div class="container" v-show="activeIndex == 12">
          <div class="bgRect animate__animated animate__slideInLeft"></div>
          <img
            class="caseImg animate__animated animate__slideInLeft"
            src="@img/product/12dungou.png"
            alt
          />
          <div class="caseIntro animate__animated animate__slideInRight">
            <div class="caseIntroTitle">
              <img :src="caseInfoList[activeIndex].icon" alt />
              <span>{{ $t(`cases.${caseInfoList[activeIndex].text}`) }}</span>
            </div>
            <p>{{ $t("cases.case13.p1") }}</p>
            <p>{{ $t("cases.case13.p2") }}</p>
            <p>{{ $t("cases.case13.p3") }}</p>
            <p>
              {{ $t("cases.case13.p4") }}
              <span>{{ $t("cases.case13.p5") }}</span
              >{{ $t("cases.case13.p6") }}
            </p>
            <p>
              {{ $t("cases.case13.p7") }}
              <span>{{ $t("cases.case13.p8") }}</span
              >{{ $t("cases.case13.p9") }}
              <span>{{ $t("cases.case13.p10") }}</span
              >{{ $t("cases.case13.p11") }}
            </p>
            <p>
              {{ $t("cases.case13.p12") }}
              <span>{{ $t("cases.case13.p13") }}</span
              >{{ $t("cases.case13.p14") }}
              <span>{{ $t("cases.case13.p5") }}</span
              >{{ $t("cases.case13.p16") }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import pageBanner from "@/components/banner";
import partTitle from "@/components/title";
import pageFooter from "@/components/footer";
import { WOW } from "wowjs";
export default {
  components: {
    pageBanner,
    partTitle,
    pageFooter,
  },
  data() {
    return {
      activeIndex: 0,
      caseInfoList: [
        {
          text: "caseInfoList_1",
          icon: require("@img/ico_snuclear power@2x.png"),
          activeIcon: require("@img/ico_s_snuclear power@2x.png"),
        },
        {
          text: "caseInfoList_2",
          icon: require("@img/ico_control arm@2x.png"),
          activeIcon: require("@img/ico_s_control arm@2x.png"),
        },
        {
          text: "caseInfoList_3",
          icon: require("@img/ico_laser@2x.png"),
          activeIcon: require("@img/ico_s_laser@2x.png"),
        },
        {
          text: "caseInfoList_4",
          icon: require("@img/ico_battery@2x.png"),
          activeIcon: require("@img/ico_s_battery@2x.png"),
        },
        {
          text: "caseInfoList_5",
          icon: require("@img/ico_wheel body@2x.png"),
          activeIcon: require("@img/ico_s_wheel body@2x.png"),
        },
        {
          text: "caseInfoList_6",
          icon: require("@img/ico_UAV@2x.png"),
          activeIcon: require("@img/ico_s_UAV@2x.png"),
        },
        {
          text: "caseInfoList_7",
          icon: require("@img/ico_sanxiang zhuanhuanqi@2x.png"),
          activeIcon: require("@img/ico_s_sanxiang zhuanhuanqi@2x.png"),
        },
        {
          text: "caseInfoList_8",
          icon: require("@img/ico_press@2x.png"),
          activeIcon: require("@img/ico_s_press@2x.png"),
        },
        {
          text: "caseInfoList_9",
          icon: require("@img/ico_assembly@2x.png"),
          activeIcon: require("@img/ico_s_assembly@2x.png"),
        },
        {
          text: "caseInfoList_10",
          icon: require("@img/ico_Pull valve@2x.png"),
          activeIcon: require("@img/ico_s_Pull valve@2x.png"),
        },

        {
          text: "caseInfoList_11",
          icon: require("@img/ico_bones@2x.png"),
          activeIcon: require("@img/ico_s_bones@2x.png"),
        },
        {
          text: "caseInfoList_12",
          icon: require("@img/ico_interlayer@2x.png"),
          activeIcon: require("@img/ico_s_interlayer@2x.png"),
        },

        {
          text: "caseInfoList_13",
          icon: require("@img/ico_shield@2x.png"),
          activeIcon: require("@img/ico_s_shield@2x.png"),
        },

        {
          text: "caseInfoList_14",
          icon: require("@img/ico_roles@2x.png"),
          activeIcon: require("@img/ico_s_roles@2x.png"),
        },
      ],
    };
  },
  created() {
    this.wow = new WOW({
      animateClass: "animated",
    });
    this.wow.init();
  },
  methods: {
    hoverItem(index) {
      if (index === 13) return;
      this.activeIndex = index;
    },
  },
};
</script>

<style lang="less" scoped>
.cases {
  padding-bottom: 10px;
  .casesHeader {
    padding-top: 70px;
    background: url("./background/img_bg_twill@2x.png") repeat;
  }
  .caseList {
    display: flex;
    align-items: center;
    .caseItem {
      width: 175px;
      height: 65px;
      display: inline-flex;
      align-items: center;
      background: rgba(51, 133, 255, 0.1);
      border-radius: 4px;
      margin-right: auto;
      margin-bottom: 20px;
      padding-left: 20px;
      font-size: 20px;
      cursor: pointer;
      color: rgba(51, 51, 51, 0.7);
      box-sizing: border-box;
      &.last {
        margin-right: 0;
      }
      &.active {
        background: linear-gradient(180deg, #285bcf 0%, #457dfb 100%);
        box-shadow: 0px 6px 12px 3px rgba(45, 97, 215, 0.4);
        border-radius: 4px;
        color: #fff;
      }
      img {
        width: 23px;
        height: 24px;
        margin-right: 9px;
      }
    }
  }
  .caseList:last-child {
    .caseItem:last-child {
      cursor: default;
    }
  }
}
.caseContent {
  padding: 56px 0 100px 0;
  .container {
    position: relative;
    display: flex;
    align-items: flex-start;
    .bgRect {
      position: absolute;
      top: 0;
      left: 0;
      width: 410px;
      height: 410px;
      background: #457dfb;
      z-index: -1;
    }
    .caseImg {
      margin: 20px 36px 0 20px;
      border-radius: 12px;
      border: 1px solid rgba(81, 134, 255, 0.2);
      width: auto;
      height: 570px;
      box-shadow: 0px 6px 12px 3px rgba(0, 0, 0, 0.1);
    }
    .caseIntro {
      flex-grow: 1;
      padding-top: 20px;
      font-size: 16px;
      color: rgba(51, 51, 51, 0.75);
      .caseIntroTitle {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        img {
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
        span {
          font-size: 24px;
          color: #5186ff;
        }
      }
      p {
        text-align: justify;
        line-height: 28px;
        margin-bottom: 10px;
        span {
          color: red;
        }
      }
      .caseIntroImg {
        width: auto;
        height: 116px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/cases.vue